import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
   
    logout: () => initialState,
    addUser: (state, action) => {
       state.push(action.payload);
    },
    userInfo: (state, action) => {
      console.log(action.payload);
      state.user = action.payload;
     
    }
  }
});

export const { logout, addUser, userInfo } = authSlice.actions;
// ? Export the authSlice.reducer to be included in the store.
export default authSlice.reducer;